import Agency from '@/services/Contacts/Agency';
import { Result } from '@/types/base';
import { FormattedMessage } from '@umijs/max';
import { Button } from 'antd';
import numeral from 'numeral';
import { useState } from 'react';
import styles from './styles.less';

const CheckBalance: React.FC = () => {
    const [balance, setBalance] = useState<{ eur: number | undefined; all: number | undefined } | undefined>();
    const [loading, setLoading] = useState<boolean>(false);

    const checkBalanceHandler = async () => {
        try {
            setLoading(true);
            const [eur, all]: [PromiseSettledResult<Result<number>>, PromiseSettledResult<Result<number>>] = await Promise.allSettled([Agency.checkBalance('EUR'), Agency.checkBalance('ALL')]);

            const getValue = (obj: PromiseSettledResult<Result<number>>) => {
                if (obj.status === 'fulfilled') {
                    return obj.value.data || 0;
                }

                if (obj.status === 'rejected') {
                    return undefined;
                }
            };

            setBalance({
                eur: getValue(eur),
                all: getValue(all),
            });
            setTimeout(() => {
                setBalance(undefined);
            }, 10000);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    if (balance) {
        return (
            <Button loading={loading} shape="round" type="primary" ghost className={styles.ml_30}>
                {typeof balance.all !== 'undefined' ? <span>{numeral(balance.all).format('0,0.00')} L / </span> : null}
                {typeof balance.eur !== 'undefined' ? <span className={styles.ml_4}>{numeral(balance.eur).format('0,0.00')} €</span> : null}
                {typeof balance.all === 'undefined' && typeof balance.eur === 'undefined' ? (
                    <span>
                        <FormattedMessage id="errors.tryAgain" />
                    </span>
                ) : null}
            </Button>
        );
    }

    return (
        <Button loading={loading} shape="round" type="primary" ghost className={styles.ml_30} onClick={checkBalanceHandler}>
            <span>
                <FormattedMessage id="common.Check Balance" />
            </span>
        </Button>
    );
};

export default CheckBalance;
